@if (show) {
<div class="modal-overlay" (click)="close.emit()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        @if (icon) {
        <fa-icon [icon]="icon"></fa-icon>
        }
        <span>{{ isEdit ? ('CONFIGURATIONS.EDIT_TITLE' | translate) : ('CONFIGURATIONS.CREATE_TITLE' | translate)
          }}</span>
      </h3>
      <button class="close-btn" (click)="close.emit()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <form (ngSubmit)="onSave()">
        @if (configType === 'delfos_server' || configType === 'di2winocr_server') {
        <div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.NAME' | translate }}</label>
            <input type="text" [(ngModel)]="configForm.name" name="name" required maxlength="255" (ngModelChange)="onInputChange()">
          </div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.URL' | translate }}</label>
            <input type="text" [(ngModel)]="configForm.url" name="url" required (ngModelChange)="onInputChange()">
          </div>
        </div>
        }
        @if (configType === 'delfos_llm') {
        <div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.NAME' | translate }}</label>
            <input type="text" [(ngModel)]="configForm.name" name="name" required maxlength="255" (ngModelChange)="onInputChange()">
          </div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.LLM_MODEL' | translate }}</label>
            <input type="text" [(ngModel)]="configForm.llm_model" name="llm_model" required
              (ngModelChange)="onInputChange()">
          </div>
          <div class="form-checkbox">
            <input type="checkbox" [(ngModel)]="configForm.thinking" name="thinking" (ngModelChange)="onInputChange()">
            <label>{{ 'CONFIGURATIONS.FORM.THINKING' | translate }}</label>
          </div>
        </div>
        }
        @if (configType === 'retriever') {
        <div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.NAME' | translate }}</label>
            <input type="text" [(ngModel)]="configForm.name" name="name" required maxlength="255" (ngModelChange)="onInputChange()">
          </div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.RETRIEVER_STRATEGY' | translate }}</label>
            <input type="text" [(ngModel)]="configForm.retriever" name="retriever" required
              (ngModelChange)="onInputChange()">
          </div>
        </div>
        }
        @if (configType === 'di2winocr_features') {
        <div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.NAME' | translate }}</label>
            <input type="text" [(ngModel)]="configForm.name" name="name" required maxlength="255" (ngModelChange)="onInputChange()">
          </div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.DISPLAY_NAME' | translate }}</label>
            <input type="text" [(ngModel)]="configForm.display_name" name="display_name" required maxlength="255" (ngModelChange)="onInputChange()">
          </div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.LAYOUT_ANALYSIS' | translate }}</label>
            <select [(ngModel)]="configForm.layoutAnalysis" name="layoutAnalysis" (ngModelChange)="onInputChange()">
              <option value="">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.NONE' | translate }}</option>
              <option value="true">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.AZURE_DOCUMENT' | translate }} (true)</option>
              <option value="1">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.TABLE_TRANSFORMER' | translate }} (1)</option>
              <option value="2">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.TABLE_STRUCTURE' | translate }} (2)</option>
              <option value="3">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.OMR_V31' | translate }} (3)</option>
              <option value="4">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.OMR_V32' | translate }} (4)</option>
            </select>
          </div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.INPUT_TYPE' | translate }}</label>
            <select [(ngModel)]="configForm.inputType" name="inputType" required (ngModelChange)="onInputChange()">
              <option value="" disabled>{{ 'CONFIGURATIONS.FORM.SELECT_PLACEHOLDER' | translate }}</option>
              <option value="path">{{ 'CONFIGURATIONS.FORM.OPTIONS.INPUT_TYPE.PATH' | translate }} (path)</option>
              <option value="base64">{{ 'CONFIGURATIONS.FORM.OPTIONS.INPUT_TYPE.BASE64' | translate }} (base64)</option>
            </select>
          </div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.OCR_TYPE' | translate }}</label>
            <select [(ngModel)]="configForm.ocrType" name="ocrType" required (ngModelChange)="onInputChange()">
              <option value="" disabled>{{ 'CONFIGURATIONS.FORM.SELECT_PLACEHOLDER' | translate }}</option>
              <option value="azure">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.AZURE' | translate }} (azure)</option>
              <option value="azure4">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.AZURE4' | translate }} (azure4)</option>
              <option value="google">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.GOOGLE' | translate }} (google)</option>
              <option value="paddle">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.PADDLE' | translate }} (paddle)</option>
              <option value="docling">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.DOCLING' | translate }} (docling)</option>
            </select>
          </div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.OUTPUT_TYPE' | translate }}</label>
            <select [(ngModel)]="configForm.outputType" name="outputType" required (ngModelChange)="onInputChange()">
              <option value="" disabled>{{ 'CONFIGURATIONS.FORM.SELECT_PLACEHOLDER' | translate }}</option>
              <option value="azure">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.AZURE' | translate }} (azure)</option>
              <option value="azure4">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.AZURE4' | translate }} (azure4)</option>
              <option value="google">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.GOOGLE' | translate }} (google)</option>
              <option value="paddle">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.PADDLE' | translate }} (paddle)</option>
              <option value="docling">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.DOCLING' | translate }} (docling)</option>
              <option value="raw_google">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.RAW_GOOGLE' | translate }} (raw_google)</option>
            </select>
          </div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.TEXT_TYPE' | translate }}</label>
            <select [(ngModel)]="configForm.textType" name="textType" required (ngModelChange)="onInputChange()">
              <option value="print">{{ 'CONFIGURATIONS.FORM.OPTIONS.TEXT_TYPE.PRINT' | translate }} (print)</option>
              <option value="hand">{{ 'CONFIGURATIONS.FORM.OPTIONS.TEXT_TYPE.HAND' | translate }} (hand)</option>
              <option value="mix">{{ 'CONFIGURATIONS.FORM.OPTIONS.TEXT_TYPE.MIX' | translate }} (mix)</option>
            </select>
          </div>
          <div class="form-checkbox">
            <input type="checkbox" [(ngModel)]="configForm.ocrCrop" name="ocrCrop" (ngModelChange)="onInputChange()">
            <label>{{ 'CONFIGURATIONS.FORM.OCR_CROP' | translate }}</label>
          </div>
          <div class="form-checkbox">
            <input type="checkbox" [(ngModel)]="configForm.autoCut" name="autoCut" (ngModelChange)="onInputChange()">
            <label>{{ 'CONFIGURATIONS.FORM.AUTO_CUT' | translate }}</label>
          </div>
          <div class="form-checkbox">
            <input type="checkbox" [(ngModel)]="configForm.enhanceDocument" name="enhanceDocument" (ngModelChange)="onInputChange()">
            <label>{{ 'CONFIGURATIONS.FORM.ENHANCE_DOCUMENT' | translate }}</label>
          </div>
          <div class="form-checkbox">
            <input type="checkbox" [(ngModel)]="configForm.sortOcr" name="sortOcr" (ngModelChange)="onInputChange()">
            <label>{{ 'CONFIGURATIONS.FORM.SORT_OCR' | translate }}</label>
          </div>
          <div class="form-group">
            <label>{{ 'CONFIGURATIONS.FORM.ADJUST_ROTATION' | translate }}</label>
            <select [(ngModel)]="configForm.adjustRotation" name="adjustRotation" (ngModelChange)="onInputChange()">
              <option value="">{{ 'CONFIGURATIONS.FORM.OPTIONS.ADJUST_ROTATION.NONE' | translate }}</option>
              <option value="1">{{ 'CONFIGURATIONS.FORM.OPTIONS.ADJUST_ROTATION.PADDLE' | translate }} (1)</option>
              <option value="2">{{ 'CONFIGURATIONS.FORM.OPTIONS.ADJUST_ROTATION.REDO_OCR' | translate }} (2)</option>
            </select>
          </div>
          <div class="form-checkbox">
            <input type="checkbox" [(ngModel)]="configForm.splitPdf" name="splitPdf" (ngModelChange)="onInputChange()">
            <label>{{ 'CONFIGURATIONS.FORM.SPLIT_PDF' | translate }}</label>
          </div>
        </div>
        }
        @if (!isEdit && configType) {
        <div class="form-group">
          <label>{{ 'CONFIGURATIONS.FORM.USERS' | translate }}</label>
          <ng-select [items]="users" bindLabel="username" bindValue="id" [multiple]="true"
            [(ngModel)]="configForm.allowed_user_ids" name="allowed_user_ids"
            [placeholder]="'CONFIGURATIONS.FORM.USERS_PLACEHOLDER' | translate"
            [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate" [closeOnSelect]="false">
          </ng-select>
        </div>
        }
        <div class="form-actions">
          <app-button [text]="'BUTTON.CANCEL' | translate" variant="secondary" (clicked)="close.emit()">
          </app-button>
          <app-button [text]="isEdit ? ('BUTTON.SAVE' | translate) : ('BUTTON.CREATE.CONFIGURATION' | translate)"
            variant="primary" [icon]="faCheck" [disabled]="!configType" (clicked)="onSave()">
          </app-button>
        </div>
      </form>
    </div>
  </div>
</div>
}